

import React from 'react';
import {
    Layout, Menu, Breadcrumb, Icon,
} from 'antd';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import * as d3 from "d3";
import csv1 from './a.csv';
import Header1 from '../public';

const { SubMenu } = Menu;
const {
    Header, Content, Footer, Sider,
} = Layout;

const rowConverter = function (d) {
    const tem = {};
	tem[d.V3] = 1;
	return {
		source: d.V1,
		target: d.V4,
		imageModality: d.V2,
		studySig: tem,
		num: 1
	}
  };


class Correlation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    rowConverter1 = d3.csv(csv1, rowConverter).then(function (links) {
        var cancer = [],
            feature = [],
            nodes;
        var flagForTag = true;

        // var button0 = document.getElementById("button")
        // button0.onclick = function() {
        //   flagForTag = !flagForTag;
        //   d3.select(this)
        //     .classed("start", flagForTag);
        // }

        links.sort(function (a, b) {
            if (a.source < b.source) {
                return -1;
            } else if (a.source > b.source) {
                return 1;
            } else {
                return 0;
            }
        })

        links.push("end");

        //由于links已经按照cancer排好序了，将links分为29块（29 cancers）来查找重复的link，其中p0用来储存每块第一个link的index
        for (var j = 1, p0 = 0, index = 0; links[j] != undefined; j++) {
            if (links[j].source != links[p0].source) { //跳转到下一块cancer了，j - p0就是这块cancer中所有的不重复link数
                cancer[index] = {
                    name: links[p0].source,
                    type: "cancer",
                    num: j - p0,
                    child: []
                };
                for (var m = p0; m < j; m++) {
                    cancer[index].child.push({
                        name: links[m].target,
                        num: links[m].num,
                        type: "feature",
                        imageModality: links[m].imageModality,
                        studySig: links[m].studySig
                    });
                    feature.push({ //由于feature原本是空的数组，后面循环中需要读取属性，所以必须先push一个feature，在判断这个feature是否在feature数组中已经出现过。
                        name: links[m].target,
                        type: "feature",
                        num: 1,
                        parent: [{
                            name: links[p0].source,
                            num: links[m].num,
                            type: "cancer",
                            imageModality: links[m].imageModality,
                            studySig: links[m].studySig
                        }]
                    })
                    for (var n = 0; n < feature.length - 1; n++) {
                        if (feature[n].name == links[m].target) {
                            feature[n].num++;
                            feature[n].parent.push({
                                name: links[p0].source,
                                num: links[m].num,
                                type: "cancer",
                                imageModality: links[m].imageModality,
                                studySig: links[m].studySig
                            });
                            feature.pop();
                        }
                    }
                }
                p0 = j;
                index++;
            }
            for (var i = p0; i < j; i++) {
                if (links[j].target == links[i].target) {
                    links[i].num++;
                    if(Object.keys(links[i].studySig).indexOf(Object.keys(links[j].studySig)[0]) < 0){
                        links[i].studySig[Object.keys(links[j].studySig)[0]] = links[j].studySig[Object.keys(links[j].studySig)[0]]
                    }else{
                        links[i].studySig[Object.keys(links[j].studySig)[0]] += 1;
                    }
                    links.splice(j, 1);
                    i--;
                    j--; //因为执行了删除数组元素，会自动将后面的数组元素挪动到前面，此时links j 会是原来删除前的下一个元素，为了不使下次循环的时候跳过这个元素，都自减1.
                }
            }
        }
        links.pop(); //算法中最后一次if(links[j].source != links[p0].source)，不会执行，因为最后一次循环，for(var j = 1, p0 = 0, index = 0; links[j] != undefined; j++)中
        //判定条件会结束，所以会导致最后一次加入cancer节点失败

        nodes = feature.concat(cancer);

        //定义svg的宽高
        var w = 800;
        var h = 800;
        var color = {
            cancer: "rgb(255,127,14)",
            feature: "rgb(31,119,180)",
            Allnode: "rgb(216,75,39)"
        };

        const tooltip = d3.select(".forceandtree")
            .append("div")
            .attr("id", "tooltip")
            .style("display", "none")
            .style("position", "absolute")
            .style("width", "150px")
            .style("padding", "8px")
            .style("background-color", "white")
            .style("-webkit-border-radius", "10px")
            .style("-moz-border-radius", "10px")
            .style("border-radius", "10px")
            .style("-webkit-box-shadow", "4px 4px 10px rgba(0, 0, 0, 0.4)")
            .style("-moz-box-shadow", "4px 4px 10px rgba(0, 0, 0, 0.4)")
            .style("box-shadow", "4px 4px 10px rgba(0, 0, 0, 0.4)")
            .style("pointer-events", "none")
            .style("font-family", "sans-serif")
            .style("font-size", "16px")
            .style("line-height", "20px")

        tooltip.append("p")
            .attr("id", "title")
            .style("font-weight", "bold")
            .text("title")

        tooltip.append("p")
            .attr("class", "value")
            .text("value")


        //定义展示力向图的svg
        var svg = d3.select(".forceandtree").append("svg")
            .attr("class", "force")
            .attr("width", w)
            .attr("height", h)
            .style("border", "4px solid rgb(160,160,160)")
            .style("border-right", "2px solid rgb(160,160,160)");

        //定义svg1树状图的放大函数
        var zoom = d3.zoom()
            .scaleExtent([1, 100])
            .on('zoom', zoomFn);

        function zoomFn() {
            d3.select('.tree')
                .select("*")
                .attr('transform', d3.event.transform);
        }

        //制作树状图：
        var svg1 = d3.select(".forceandtree").append("svg")
            .attr("class", "tree")
            .attr("width", w * 0.92)
            .attr("height", h)
            .style("border", "4px solid rgb(160,160,160)")
            .style("border-left", "2px solid rgb(160,160,160)")
            .call(zoom);
        //制作SVG1提示语
        svg1.append("text")
        svg1.append("text")
            .attr("x", 40)
            .attr("y", h / 3)
            .attr("font-size", 55)
            .attr("fill", "gray")
            .text("click nodes on the".toUpperCase());
        svg1.append("text")
            .attr("x", 40)
            .attr("y", h / 3 + 60)
            .attr("font-size", 55)
            .attr("fill", "gray")
            .text("left box to generate a".toUpperCase());
        svg1.append("text")
            .attr("x", 40)
            .attr("y", h / 3 + 120)
            .attr("font-size", 55)
            .attr("fill", "gray")
            .text("a tree graph".toUpperCase())

        //这是节点大小与cancer或feature关联数num的比例尺数组，0为cancer的，1为feature的
        var rScale = [d3.scaleLinear()
            .domain([
                d3.min(cancer, function (d) {
                    return d.num;
                }),
                d3.max(cancer, function (d) {
                    return d.num;
                })
            ]),

        d3.scaleLinear()
            .domain([
                d3.min(feature, function (d) {
                    return d.num;
                }),
                d3.max(feature, function (d) {
                    return d.num;
                })
            ])
        ]

        rScale[0].range([
            Math.sqrt((rScale[0].domain()[0] * 70) / Math.PI),
            Math.sqrt((rScale[0].domain()[1] * 10) / Math.PI)
        ])

        rScale[1].range([
            Math.sqrt((rScale[1].domain()[0] * 70) / Math.PI),
            Math.sqrt((rScale[1].domain()[1] * 30) / Math.PI)
        ])

        //初始化一个force layout
        var force = d3.forceSimulation(nodes)
            .force("charge", d3.forceManyBody().strength(-120).distanceMax(60).distanceMin(30))
            .force("center", d3.forceCenter(10).x(w / 2).y(h / 2))
            .force("colide", d3.forceCollide().radius(function (node) {
                if (node.type == "cancer") {
                    return rScale[0](node.num) * 1.5;
                } else {
                    return rScale[1](node.num) * 1.6;
                }
            }).strength(1).iterations(14))
            .force("link", d3.forceLink(links).id(function (d) {
                return d.name;
            }).strength(0.03).distance(30).iterations(5));

        //定义力向图的边
        var edges = svg.append("g")
            .attr("class", "lines")
            .attr("stroke", "#999")
            .attr("stroke-opacity", 0.4)
            .selectAll("line")
            .data(links)
            .enter()
            .append("line")
            .attr("stroke-width", function (d) {
                return Math.sqrt(d.num);
            })
            .attr("stroke", "gray");

        //定义力向图的节点，使用g分组标签包括节点的文字说明与节点圆圈符号
        var circles = svg.selectAll(".nodes")
            .data(nodes)
            .enter()
            .append("g")
            .attr("class", "nodes")
            .call(d3.drag() //Define what to do on drag events
                .on("start", dragStarted)
                .on("drag", dragging)
                .on("end", dragEnded))
            .on("click", function (d) {
                treeGen(d);
                changeStyle(d);
            })
            .on("mouseover", function (d) {
                if (flagForTag) {
                    creatTag(d, false);
                }
            })
            .on("mouseout", function (d) {
                d3.select("#tooltip").style("display", "none");
            });

        //向nodes类的g标签内添加节点圆圈元素
        circles.append("circle")
            .attr("r", function (d) {
                if (d.type == "cancer") {
                    return rScale[0](d.num);
                } else {
                    return rScale[1](d.num);
                }
            })
            .attr("fill", function (d) {
                return color[d.type];
            })
            .attr("stroke", "#fff")
            .attr("stroke-width", 1.5)
            .style("opacity", 0.95);

        //向nodes类的g标签内添加节点文字说明
        circles.append("text")
            .attr("text-anchor", "middle")
            .attr("dx", "0px")
            .attr("dy", function (d) {
                if (d.num > 15 || d.type == "cancer") {
                    return "2px";
                } else {
                    return "-8px";
                }
            })
            .style("font-size", "12px")
            .style("color", "gray")
            .text(function (d) {
                if (d.type == "cancer") {
                    return d.name;
                } else if (d.num > 15) {
                    return d.name;
                } else if (d.num == 1) {
                    return d.name;
                }
            });

        var r = 10; //r本意是所有节点的半径，用来作为边界
        force.on("tick", function () {
            circles.attr("transform", function (d) {
                d.x = Math.max(r, Math.min(w - r, d.x));
                d.y = Math.max(r, Math.min(h - r, d.y));
                return "translate(" + d.x + "," + d.y + ")";
            });
            edges.attr("x1", function (d) {
                return d.source.x = Math.max(r, Math.min(w - r, d.source.x))
            })
                .attr("y1", function (d) {
                    return d.source.y = Math.max(r, Math.min(h - r, d.source.y))
                })
                .attr("x2", function (d) {
                    return d.target.x = Math.max(r, Math.min(w - r, d.target.x))
                })
                .attr("y2", function (d) {
                    return d.target.y = Math.max(r, Math.min(h - r, d.target.y))
                })
        })

        //Define drag event functions
        function dragStarted(d) {
            if (!d3.event.active) force.alphaTarget(0.08).restart();

            d.fx = d.x;
            d.fy = d.y;
        }

        function dragging(d) {
            d.fx = d3.event.x;
            d.fy = d3.event.y;
        }

        function dragEnded(d) {
            if (!d3.event.active) force.alphaTarget(0);
            d.fx = null;
            d.fy = null;
        }

        //制作图例
        var h1 = 26;
        var w1 = 70;
        var legend = svg.append("g")
            .attr("class", "legend");

        legend.append("rect")
            .attr("x", w - r - w1)
            .attr("y", r)
            .attr("height", h1)
            .attr("width", w1)
            .attr("fill", color.feature);

        legend.append("text")
            .attr("x", w - r - w1 / 2)
            .attr("y", r + 18)
            .attr("text-anchor", "middle")
            .attr("font-size", 15)
            .text("Features")
            .attr("fill", "white");

        legend = svg.append("g")
            .attr("class", "legend")
            .on("click", function () {

                circles.select("circle")
                    .transition("nodechange")
                    .duration(300)
                    .attr("fill", function (node) {
                        return color[node.type];
                    })
                    .attr("r", function (node) {
                        if (node.type == "cancer") {
                            return rScale[0](node.num);
                        } else {
                            return rScale[1](node.num);
                        }
                    })
                edges.style("stroke-opacity", 0.4);

                circles.select("text")
                    .text(function (node) {
                        if (node.type == "cancer") {
                            return node.name;
                        } else if (node.num > 15) {
                            return node.name;
                        } else if (node.num == 1) {
                            return node.name;
                        }
                    })
                    .attr("font-size", "3px")
            });

        legend.append("rect")
            .attr("x", w - r - w1)
            .attr("y", 2 * r + h1)
            .attr("height", h1)
            .attr("width", w1)
            .attr("fill", color.Allnode);

        legend.append("text")
            .attr("x", w - r - w1 / 2)
            .attr("y", 2 * r + h1 + 18)
            .attr("text-anchor", "middle")
            .attr("font-size", 15)
            .text("Show All")
            .attr("fill", "white");

        //这个函数用来接受一个datum参数，其中包含生成一个树状图的全部信息，前面的力向图节点分组标签的onclik事件会触发该函数，该函数在svg1上生成一个树状图。
        function treeGen(d) {
            //清空svg1标签内的所有内容
            document.querySelector('.tree').innerHTML = '';
            //
            var h1;
            var w1 = w * 0.35;
            var n = 150;
            var hierarchyData = d3.hierarchy(d, function (d) {
                if (d.type == "cancer") {
                    return d.child;
                } else if (d.type == "feature") {
                    return d.parent;
                }
            })

            if (hierarchyData.children.length > n) {
                h1 = 3 * h;
            } else {
                h1 = h - 2 * r;
            }

            var tree = d3.tree()
                .size([h1, w1])
                .separation(function (a, b) {
                    return (a.parent == b.parent ? 1 : 2) / a.depth;
                });

            var treeData = tree(hierarchyData);
            var nodes = treeData.descendants();
            var links = treeData.links();

            var linkDrawer = d3.linkHorizontal()
                .x(function (d) {
                    return d.y;
                })
                .y(function (d) {
                    return d.x;
                });

            var g = svg1
                .append("g")
                .attr("class", "treeNode")
                .attr("transform", function () {
                    if (hierarchyData.children.length > n) {
                        return "translate(" + 20 * r + "," + h1 / -3 + ")";
                    } else {
                        return "translate(" + 20 * r + "," + r + ")";
                    }
                })

            //adds the links between the nodes
            var link = g.selectAll(".link")
                .data(links)
                .enter()
                .append("path")
                .attr("class", "link")
                .attr("d", linkDrawer)
                .attr("fill", "none")
                .attr("stroke", "#999")
                .attr("stroke-opacity", 0.4)
                .attr("stroke-width", function (d) {
                    return Math.sqrt(d.target.data.num);
                })

            // adds each node as a group
            var node = g.selectAll(".node")
                .data(nodes)
                .enter()
                .append("g")
                .attr("class", function (d) {
                    return "node" +
                        (d.children ? " node--internal" : " node--leaf");
                })
                .attr("transform", function (d) {
                    return "translate(" + d.y + "," + d.x + ")";
                })
                .on("click", function (d) {
                    var datum;
                    if (d.data.type == "cancer") {
                        for (var i = 0; i < cancer.length; i++) {
                            if (cancer[i].name == d.data.name) {
                                datum = cancer[i];
                            }
                        }
                    } else {
                        for (var i = 0; i < feature.length; i++) {
                            if (feature[i].name == d.data.name) {
                                datum = feature[i];
                            }
                        }
                    }
                    treeGen(datum);
                    changeStyle(datum);
                })
                .on("mouseover", function (d) {
                    var datum;
                    if (d.data.type == "cancer") {
                        for (var i = 0; i < cancer.length; i++) {
                            if (cancer[i].name == d.data.name) {
                                datum = cancer[i];
                            }
                        }
                    } else {
                        for (var i = 0; i < feature.length; i++) {
                            if (feature[i].name == d.data.name) {
                                datum = feature[i];
                            }
                        }
                    }
                    if (flagForTag) {
                        creatTag(datum, true, links);
                    }
                })
                .on("mouseout", function (d) {
                    d3.select("#tooltip").style("display", "none");
                });
            // adds the circle to the node
            node.append("circle")
                .attr("r", function (d) {
                    if (nodes.length > 50) {
                        return rScale[0](d.data.num) * 0.3;
                    } else {

                        return rScale[0](d.data.num) * 0.9;

                    }
                })
                .attr("fill", function (d) {
                    return color[d.data.type];
                });

            // adds the text to the node
            node.append("text")
                .attr("dy", "1.5px")
                .attr("font-size", function () {
                    if (nodes.length > 150) {
                        return (h1 / nodes.length) * 0.9 + "px";
                    } else {
                        return -1 * Math.sqrt(nodes.length) + 18 + "px";
                    }
                })
                .attr("dx", function (d) {
                    return d.children ? -25 : 25;
                })
                .style("text-anchor", function (d) {
                    return d.children ? "end" : "start";
                })
                .text(function (d) {
                    return d.data.name;
                });

            node.append("text")
                .attr("dy", function () {
                    if (nodes.length > 150) {
                        return (h1 / nodes.length) * 0.45 + "px";
                    } else {
                        return (-1 * Math.sqrt(nodes.length) + 18) * 0.5 + "px";
                    }
                })
                .attr("font-size", function () {
                    if (nodes.length > 150) {
                        return (h1 / nodes.length) * 0.9 + "px";
                    } else {
                        return -1 * Math.sqrt(nodes.length) + 18 + "px";
                    }
                })
                .attr("dx", function (d) {
                    return d.children ? 0 : -10;
                })
                .style("text-anchor", function (d) {
                    return d.children ? "start" : "end";
                })
                .text(function (d) {
                    return d.children ? "" : d.data.num;
                });

        }

        function changeStyle2(d) {

            var checklist = [];

            checklist.push(d.name);

            if (d.type == "cancer") {
                for (var i = 0; i < d.child.length; i++) {
                    checklist.push(d.child[i].name);
                }
            } else {
                for (var i = 0; i < d.parent.length; i++) {
                    checklist.push(d.parent[i].name);
                }
            }

            var fontSize = 60 / checklist.length;

            circles.select("circle")
                .transition("nodechange")
                .duration(300)
                .attr("fill", function (node) {
                    if (checklist.indexOf(node.name) > -1) {
                        return "purple";
                    } else {
                        return color[node.type];
                    }
                })
                .attr("r", function (node) {
                    if (checklist.indexOf(node.name) > -1) {
                        if (node.type == "cancer") {
                            return rScale[0](node.num) + 2;
                        } else {
                            return rScale[1](d.num) + 15;
                        }
                    } else {
                        return 0;
                    }
                })
                .style("opacity", 0.95)
                .on("end", function () {
                    d3.select(this)
                        .transition("nodechange1")
                        .duration(1000)
                        .attr("fill", function (d) {
                            return color[d.type];
                        })
                        .attr("r", function (d) {
                            if (checklist.indexOf(d.name) > -1) {
                                if (d.type == "cancer") {
                                    return rScale[0](d.num);
                                } else {
                                    return rScale[1](d.num);
                                }
                            }
                        })
                });

            circles.select("text")
                .attr("font-size", function (node) {
                    if (checklist.indexOf(node.name) > -1) {
                        return fontSize * 10 + "px";
                    } else {
                        return "12px";
                    }
                })
                .text(function (node) {
                    if (checklist.indexOf(node.name) > -1) {
                        return node.name;
                    } else {
                        return "";
                    }
                })

            edges.style("stroke-opacity", function (line) {
                if (line.source.name == d.name || line.target.name == d.name) {
                    return 0.95;
                } else {
                    return 0;
                }
            });
        }

        function changeStyle(d) {

            var checklist = [];

            if (d.type == "cancer") {
                for (var i = 0; i < d.child.length; i++) {
                    checklist.push(d.child[i].name);
                }
                checklist.push(d.name);
            } else {
                for (var i = 0; i < d.parent.length; i++) {
                    checklist.push(d.parent[i].name);
                }
                checklist.push(d.name);
            }

            var fontSize = 60 / checklist.length;

            circles.select("circle")
                .transition("nodechange")
                .duration(300)
                .attr("fill", function (node) {
                    if (checklist.indexOf(node.name) > -1) {
                        return "purple";
                    } else {
                        return color[node.type];
                    }
                })
                .attr("r", function (node) {
                    if (checklist.indexOf(node.name) > -1) {
                        if (node.type == "cancer") {
                            return rScale[0](node.num) + 2;
                        } else {
                            return rScale[1](d.num) + 15;
                        }
                    } else {
                        if (node.type == "cancer") {
                            return rScale[0](node.num);
                        } else {
                            return rScale[1](node.num);
                        }
                    }
                })
                .on("end", function () {
                    d3.select(this)
                        .transition("nodechange1")
                        .duration(1000)
                        .attr("fill", function (d) {
                            return color[d.type];
                        })
                        .attr("r", function (d) {
                            if (d.type == "cancer") {
                                return rScale[0](d.num);
                            } else {
                                return rScale[1](d.num);
                            }
                        })
                        .style("opacity", function (d) {
                            if (checklist.indexOf(d.name) > -1) {
                                return 1;
                            } else {
                                return 0.4;
                            }
                        });

                });

            circles.select("text")
                .attr("font-size", function (node) {
                    if (checklist.indexOf(node.name) > -1) {
                        return fontSize * 100 + "px";
                    } else {
                        return "12px";
                    }
                })
                .text(function (node) {
                    if (checklist.indexOf(node.name) > -1) {
                        return node.name;
                    } else {
                        return "";
                    }
                })


            edges.style("stroke-opacity", function (line) {
                if (line.source.name == d.name || line.target.name == d.name) {
                    return 0.95;
                } else {
                    return 0.1;
                }
            });
        }

        function creatTag(d, flag, links) {
            d3.select("#tooltip").selectAll(".value")
                .text("")

            var xPosition = d3.event.x + (document.documentElement.scrollLeft ? document.documentElement.scrollLeft : document.body.scrollLeft);
            var yPosition = d3.event.y + (document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop) + 10;

            //Update the tooltip position and value
            d3.select("#tooltip")
                .style("width", 12 * (d.type.length + d.name.length) + "px")
                .style("left", xPosition + "px")
                .style("top", yPosition + "px")
                .select("#title")
                .text(function () {
                    return d.type[0].toUpperCase() + d.type.substring(1, d.type.length) + ": " + d.name[0].toUpperCase() + d.name.substring(1, d.name.length);
                })

            var textString;

            if (d.type == "cancer") {
                textString = "Have " + d.num + " features connected";
            } else {
                if (d.num == 1) {
                    textString = "Only have " + d.num + " cancer connected";
                } else {
                    textString = "Have " + d.num + " cancers connected";
                }
            }

            if(flag) {
                for(var i = 0; i < links.length; i++) {
                    if(d.name == links[i].target.data.name) {
                        var stars= "";
                        var studySigString = "";
                        var m = (d.type.length + d.name.length);
                        for(var j = 0; j < m * 1.6; j++){
                            stars += "*";
                        }
                        for(var n in links[i].target.data.studySig){
                            studySigString = n + ": " + links[i].target.data.studySig[n] + " times , " +studySigString;
                        }
                        textString =links[i].source.data.type + ": " + links[i].source.data.name + " " + stars + " " + "Image Modality:    " + links[i].target.data.imageModality + " " + stars + " Study Significance:    " + studySigString.slice(0,studySigString.length-2);                    }
                }
            }
            d3.select("#tooltip").select(".value")
                .text(textString)
                .style("font-size", "14px");

            //Show the tooltip
            d3.select("#tooltip").style("display", "");
        }

        setTimeout(listbox, 900)
        function listbox() {
            var position;
            position = { left: document.querySelector(".force").getBoundingClientRect().left + (document.documentElement.scrollLeft ? document.documentElement.scrollLeft : document.body.scrollLeft), top: document.querySelector(".force").getBoundingClientRect().top + (document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop) }//myElement.getBoundingClientRect()
            var select_w = 130;
            var select_h = 35;


            const sel = d3.select(".forceandtree")
                .append("select")
                .attr("id", "inds")
                .style("width", select_w + "px")
                .style("height", select_h + "px")
                .style("position", "absolute")
                .style("left", position.left + w - select_w - 6 + "px")
                .style("top", position.top + 2.45 * select_h + "px")
                .style("color", "white")
                .style("border", "none")
                .style("background-color", color.cancer);
            sel.append("option")
                .attr("slecte", "selected")
                .text("  Cancers")

            sel.selectAll("option")
                .data(cancer)
                .enter()
                .append("option")
                .attr("value", function (d) {
                    return d.name;
                })
                .text(function (d) {
                    return d.name;
                });

            sel.on("change", function () {
                var sect = document.getElementById("inds");
                var section = sect.options[sect.selectedIndex].value;

                for (var i = 0; i < cancer.length; i++) {
                    if (cancer[i].name == section) {
                        treeGen(cancer[i]);
                        changeStyle2(cancer[i]);
                    }
                }

            })
        }




    })

    shouldComponentUpdate() { return false }
    render() {
        return (
            <div className='Login-component'>
                <Header1></Header1>
                <Content style={{ padding: '0 50px' }}>

                    <Layout style={{ background: '#fff' }}>
                        <Sider width={200} style={{ background: '#fff' }}>
                            <Menu
                                mode="inline"
                                defaultSelectedKeys={['1']}
                                defaultOpenKeys={['sub1']}
                                style={{ height: '100%' }}
                            >
                                <SubMenu key="sub1" title={<span><Icon type="user" />Atlas</span>}>
                                    <Menu.Item key="2"><Link to="/mifa-intro">Introduction</Link></Menu.Item>
                                    <Menu.Item key="1"><Link to="/mifa-correlation">Correlation</Link></Menu.Item>
                                </SubMenu>
                            </Menu>
                        </Sider>
                        <Content className="forceandtree">

                        </Content>
                    </Layout>
                </Content>
            </div>

        )
    }
}
export default Correlation;